export const TIMELINE_CATEGORIES = [
  { id: 'all', label: 'All' },
  { id: 'personal', label: 'Personal' },
  { id: 'publications', label: 'Publications' },
  { id: 'encounters', label: 'Encounters' },
  { id: 'concepts', label: 'Concepts' }
];

// Dates are ISO strings. Some entries use year-only precision (YYYY-01-01).
export const TIMELINE_EVENTS = [
  {
    id: '1875-birth',
    date: '1875-07-26',
    title: 'Born in Kesswil, Switzerland',
    category: 'personal',
    summary: 'Begins the life of Carl Gustav Jung (1875–1961).'
  },
  {
    id: '1895-basel',
    date: '1895-01-01',
    title: 'Begins medical studies at the University of Basel',
    category: 'personal',
    summary: 'Early academic formation before clinical psychiatry.'
  },
  {
    id: '1900-burgholzli',
    date: '1900-01-01',
    title: 'Joins the Burgholzli psychiatric hospital (Zurich)',
    category: 'personal',
    summary: 'Clinical work grounds later theoretical development.'
  },
  {
    id: '1902-dissertation',
    date: '1902-01-01',
    title: "Doctoral dissertation: 'On the Psychology and Pathology of So-Called Occult Phenomena'",
    category: 'publications',
    summary: 'Early engagement with dissociation, symbolism, and interpretation.'
  },
  {
    id: '1903-marriage',
    date: '1903-02-14',
    title: 'Marries Emma Rauschenbach',
    category: 'personal',
    summary: 'Family life develops alongside clinical and scholarly work.'
  },
  {
    id: '1906-word-association',
    date: '1906-01-01',
    title: 'Word association studies gain prominence',
    category: 'publications',
    summary: 'Empirical methods used to study complexes and affect.'
  },
  {
    id: '1907-freud',
    date: '1907-03-03',
    title: 'First meeting with Sigmund Freud',
    category: 'encounters',
    summary: 'A pivotal collaboration, followed by theoretical rupture.'
  },
  {
    id: '1909-america',
    date: '1909-01-01',
    title: 'Travels to America with Freud',
    category: 'encounters',
    summary: 'Public psychoanalytic moment before the split.'
  },
  {
    id: '1912-symbols',
    date: '1912-01-01',
    title: 'Publishes work later known as "Symbols of Transformation"',
    category: 'publications',
    summary: 'Expands the symbolic horizon beyond Freud’s framework.'
  },
  {
    id: '1913-unconscious',
    date: '1913-01-01',
    title: 'Begins the "confrontation with the unconscious"',
    category: 'personal',
    summary: 'Inner work that informs later notions of archetype and individuation.'
  },
  {
    id: '1916-sermons',
    date: '1916-01-01',
    title: 'Writes "Seven Sermons to the Dead" (private circulation)',
    category: 'concepts',
    summary: 'A mythopoetic articulation of psychological experience.'
  },
  {
    id: '1919-archetypes',
    date: '1919-01-01',
    title: 'Develops the concept of archetypes (matures over time)',
    category: 'concepts',
    summary: 'Archetypes framed as recurrent structural patterns in psyche and myth.'
  },
  {
    id: '1921-types',
    date: '1921-01-01',
    title: 'Publishes "Psychological Types"',
    category: 'publications',
    summary: 'Systematizes attitudes and functions as a map of consciousness.'
  },
  {
    id: '1924-pueblo',
    date: '1924-01-01',
    title: 'Visits Pueblo communities in the American Southwest',
    category: 'encounters',
    summary: 'Cross-cultural observations that sharpen questions of symbol and worldview.'
  },
  {
    id: '1928-individuation',
    date: '1928-01-01',
    title: 'Individuation becomes a central developmental frame',
    category: 'concepts',
    summary: 'A long arc of integration toward greater psychic wholeness.'
  },
  {
    id: '1934-collective-unconscious',
    date: '1934-01-01',
    title: 'Work on the collective unconscious and archetypes consolidates',
    category: 'concepts',
    summary: 'Psychology reads symbolic traditions as transpersonal structures.'
  },
  {
    id: '1938-india',
    date: '1938-01-01',
    title: 'Travels to India',
    category: 'encounters',
    summary: 'Comparative lens broadened through contact with Asian traditions.'
  },
  {
    id: '1944-alchemy',
    date: '1944-01-01',
    title: 'Publishes "Psychology and Alchemy"',
    category: 'publications',
    summary: 'Alchemy treated as a symbolic language for transformation.'
  },
  {
    id: '1944-illness',
    date: '1944-01-01',
    title: 'Serious illness and near-death experience',
    category: 'personal',
    summary: 'Later reflections are shaped by an intensified existential perspective.'
  },
  {
    id: '1951-aion',
    date: '1951-01-01',
    title: 'Publishes "Aion"',
    category: 'publications',
    summary: 'A dense symbolic-psychological reading of the Self, shadow, and the aeon motif.'
  },
  {
    id: '1952-answer-job',
    date: '1952-01-01',
    title: 'Publishes "Answer to Job"',
    category: 'publications',
    summary: 'Continues symbolic-theological tensions in psychological form.'
  },
  {
    id: '1961-death',
    date: '1961-06-06',
    title: 'Dies in Kusnacht, Switzerland',
    category: 'personal',
    summary: 'Legacy continues through the Collected Works and analytic tradition.'
  }
];

